import React, { useEffect, useState } from "react";
import { DashboardShell } from "@/components/DashboardLayout";
import { BackButton } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, fmtSASTDateTime, fmtZAR, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2, XCircle, FileText } from "lucide-react";

export default function AdminWallet() {
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState({});

  const load = () => api.get("/admin/topups", { params: { status: "pending" } }).then(({ data }) => setItems(data.topups || []));
  useEffect(() => { load(); }, []);

  const review = async (id, status) => {
    try {
      await api.post(`/admin/topups/${id}/review`, { status, notes: notes[id] || "" });
      toast.success(`Top-up ${status}`);
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <DashboardShell role="admin">
      <BackButton to="/admin" />
      <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Top-ups</p>
      <h1 className="font-display mt-2 text-3xl font-bold text-[#0A2540]">Pending top-up requests ({items.length})</h1>

      <div className="mt-6 space-y-5">
        {items.length === 0 && <div className="bg-white border border-[#E5E7EB] rounded-2xl p-10 text-center text-[#666666]">No pending top-ups.</div>}
        {items.map((t) => (
          <div key={t.id} data-testid={`topup-card-${t.id}`} className="bg-white border border-[#E5E7EB] rounded-2xl p-6">
            <div className="flex items-start justify-between flex-wrap gap-3">
              <div>
                <p className="font-display text-2xl font-bold text-[#0A2540]">{fmtZAR(t.amount)}</p>
                <p className="text-sm text-[#666666] mt-1">{t.merchant?.contact_name || t.merchant?.business_name || "Merchant"} · {fmtSASTDateTime(t.created_at)}</p>
                {t.reference && <p className="text-xs text-[#666666] mt-1">Ref: {t.reference}</p>}
                {t.notes && <p className="text-xs text-[#666666] mt-1">Notes: {t.notes}</p>}
              </div>
              {t.proof_file_id && (
                <a href={`${process.env.REACT_APP_BACKEND_URL}/api/files/${t.proof_file_id}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm px-3 py-2 bg-[#F8F9FA] border border-[#E5E7EB] rounded-full text-[#0A2540] hover:border-[#00C4B4]">
                  <FileText size={14} /> View proof
                </a>
              )}
            </div>
            <Textarea data-testid={`topup-notes-${t.id}`} rows={2} placeholder="Admin notes" className="mt-4" value={notes[t.id] || ""} onChange={(e) => setNotes({ ...notes, [t.id]: e.target.value })} />
            <div className="flex gap-2 mt-3">
              <Button data-testid={`topup-approve-${t.id}`} onClick={() => review(t.id, "approved")} className="bg-[#00C853] hover:bg-[#00B348] text-white"><CheckCircle2 size={16} className="mr-2" />Approve & credit</Button>
              <Button data-testid={`topup-reject-${t.id}`} onClick={() => review(t.id, "rejected")} variant="outline" className="border-red-300 text-red-700 hover:bg-red-50"><XCircle size={16} className="mr-2" />Reject</Button>
            </div>
          </div>
        ))}
      </div>
    </DashboardShell>
  );
}
